"use strict";

import Page from "./Permitters.jsx";

export const auth = true;
export const title = "i18n:permits.permitters.pageTitle";
export const Component = Page;
